sn-long-content-type-1 {
  display: block;
  background-color: $background-color-secondary;

  @include section-margin-bottom;

  .sn-long-content-type-1__container {
    // Match the signnow me-container width so this lines up with the
    // me-container-based blocks on the page ($media-desktop (1440) was too wide).
    max-width: $sn-container-max-width;
    margin: 0 auto;
    padding: 0 $spacing-xl $spacing-5xl;
    display: flex;
    flex-direction: column;
    gap: $spacing-3xl;
    margin-bottom: $spacing-3xl;

    @include desktop {
      flex-direction: row;
      align-items: flex-start;
      gap: $spacing-4xl;
      padding: 0 $spacing-3xl $spacing-6xl;
    }

    @include desktop-lg {
      padding-top: 0;
      padding-bottom: $spacing-7xl;
      margin-bottom: $spacing-7xl;
      gap: $spacing-7xl;
    }
  }

  .sn-long-content-type-1__media {
    display: none;
    flex-shrink: 0;
    width: 35%;

    @include desktop-lg {
      display: block;
    }
  }

  .sn-long-content-type-1__picture {
    display: block;
    width: 100%;

    @include desktop-lg {
      margin-top: -50px;
    }
  }

  .sn-long-content-type-1__image {
    display: block;
    width: 100%;
    height: auto;
    border-radius: $radius-size-md;
  }

  .sn-long-content-type-1__content {
    flex: 1;
    min-width: 0;
    padding-top: $spacing-3xl;
    display: flex;
    flex-direction: column;

    @include desktop {
      padding-top: $spacing-5xl;
    }
  }

  .sn-long-content-type-1__subtitle {
    margin: 0 0 $spacing-3xl;
  }

  .sn-long-content-type-1__body {
    h2 {
      font-size: 1.375rem;
      font-weight: 700;
      color: $text-color-primary;
      margin: $spacing-3xl 0 $spacing-md;
      line-height: 1.2;

      @include desktop-lg {
        font-size: map-get($font-sizes, 4xl);
      }

      &:first-child {
        margin-top: 0;
      }
    }

    h3,
    h4 {
      font-weight: 700;
      color: $text-color-primary;
      margin: $spacing-lg 0 $spacing-sm;
      line-height: 1.3;
    }

    p {
      color: $text-color-primary;
      margin: 0 0 $spacing-md;
      line-height: 1.6;
    }

    ol,
    ul {
      margin: 0 0 $spacing-md;
      padding-left: $spacing-xl;
      color: $text-color-primary;
      line-height: 1.6;
    }

    li {
      margin-bottom: $spacing-sm;
    }

    strong {
      font-weight: 700;
    }

    em {
      font-style: italic;
    }
  }
}
